import { render, staticRenderFns } from "./attachmentList.vue?vue&type=template&id=e2b0a8d2&scoped=true&"
import script from "./attachmentList.vue?vue&type=script&lang=js&"
export * from "./attachmentList.vue?vue&type=script&lang=js&"
import style0 from "./attachmentList.vue?vue&type=style&index=0&id=e2b0a8d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b0a8d2",
  null
  
)

export default component.exports